export default {
  presets: {
    light: {
      primary: '#1D9E75',
      secondary: '#0F6E56',
      backgroundPrimary: '#FAF7F0',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#FDFCF9',
      backgroundCardSecondary: '#E9F8F1',
      success: '#16855F',
      info: '#33739F',
      danger: '#CF4436',
      warning: '#DE9A2B',
    },
    dark: {
      backgroundCardPrimary: '#111827',
      backgroundCardSecondary: '#0f172a',
    },
  },
}
